// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import Dialog, { DialogProps } from "../ui/Dialog";
import React, { FunctionComponent } from "react";

const renderedUrls = {};

const TestRunWarningDialog: FunctionComponent<DialogProps> = props => {
  const href = document.location.href;
  if (renderedUrls[href]) {
    return null;
  }
  return (
    <Dialog
      {...props}
      onClose={() => {
        renderedUrls[href] = true;
      }}
    />
  );
};

export default TestRunWarningDialog;
